import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { DocumentViews } from "../../../../api/types/documentActivityTypes";

export interface Props {
  showFilePreview: (documentView: DocumentViews) => void;
}

type ContextValue = Props;

export const DocumentViewsGridContext = createContext<ContextValue | undefined>(undefined);

export const useDocumentViewsGridContext = () =>
  defined(use(DocumentViewsGridContext), "Attempt to use DocumentViewsGridContext without provider");
